import React, { useState } from 'react'

import Container from 'components/layouts/atoms/Container'
import MarkdownContent from 'components/common/atoms/MarkdownContent'
import SectionContainer from 'components/layouts/atoms/SectionContainer'
import Typography from 'components/common/atoms/Typography'

import addEventGA from 'utils/addEventGA'
import { useQuery } from '@apollo/react-hooks'
import { GET_HOMEPAGE_SEO_TEXT } from '@graphql/queries/homepageQueries'
import { useTheme } from 'emotion-theming'
import Ellipsis from 'components/common/atoms/Ellipsis'
import { css } from '@emotion/core'
import SVGIcon from 'components/common/atoms/SVGIcon'
import TextLink from 'components/common/atoms/TextLink'
import BasicContainer from 'components/common/atoms/BasicContainer'

const seoTextStyle = (theme: ThemeType) => css`
  .seo-text {
    &__content {
      margin-bottom: 24px;
      a {
        font-size: inherit;
        color: ${theme.campus.aqua30};
        text-decoration: none;
      }
      strong {
        font-weight: bold;
      }
      .campus-markdown > p {
        color: inherit;
      }
    }
  }
`

const backToTopStyle = css`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  @media screen and (min-width: 768px) {
    margin-top: 40px;
  }
  .back-to-top {
    &__btn {
      border-radius: 20px;
      box-shadow: 0 1px 4px 0 rgba(112, 114, 125, 0.2);
      border: solid 1px #dcdee3;
      background-color: #ffffff;
      padding: 8px 16px;
      cursor: pointer;
    }
    &__content {
      display: flex;
      align-items: center;
      span {
        margin-left: 8px;
      }
    }
  }
`

const SeoText = () => {
  const [isShownAll, setIsShownAll] = useState(false)
  const theme: ThemeType = useTheme()
  const { data } = useQuery(GET_HOMEPAGE_SEO_TEXT, { notifyOnNetworkStatusChange: true })
  const seoTextVal = data?.homepage?.seoText

  const backToTop = () => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    })
    addEventGA('engagement', 'global', 'ga/global/button-back-to-top')
  }
  return (
    <div className="seo-text" css={seoTextStyle(theme)}>
      <SectionContainer smallPadding withPaddingBottom backgroundColor={theme.gray.gray10}>
        <Container isMobileFull>
          <BasicContainer>
            <Typography
              tagName="div"
              variant="paragraph"
              level="1"
              color={theme.gray.gray70}
              className="seo-text__content"
            >
              {isShownAll ? (
                <MarkdownContent content={seoTextVal} />
              ) : (
                <Ellipsis text={seoTextVal} clamp={10} useMarkdown />
              )}
            </Typography>
            <TextLink
              text={isShownAll ? 'Sembunyikan' : 'Selengkapnya'}
              onClick={(e) => {
                e.preventDefault()
                setIsShownAll(!isShownAll)
              }}
            />
            <div className="back-to-top" css={backToTopStyle}>
              <button type="button" onClick={backToTop} className="back-to-top__btn">
                <div className="back-to-top__content">
                  <SVGIcon name="backtotop" color={theme.gray.gray50} size="md" />
                  <Typography tagName="span" variant="body" level="2" fontWeight="bold">
                    Back to Top
                  </Typography>
                </div>
              </button>
            </div>
          </BasicContainer>
        </Container>
      </SectionContainer>
    </div>
  )
}

export default SeoText
